import { asSounds } from "../../src/shell/Sound";
import { parseRequire } from "../../src/utils/parseImageUrl";




export const sounds = asSounds({
    // keyboard_typing: { url: require("@lss/common/game/assets/sounds/331656__trollarch2__keyboard-typing.mp3") },
    // phone_message: { url: require("@lss/common/game/assets/sounds/555154__nomerodin1__vibrating-message.wav") },
    // test: { url: require("@lss/common/game/assets/sounds/Ringtone.wav") },
});
export const music = asSounds({
    // V5AnnMCFirstSex: { url: require("@lss/common/game/assets/sounds/Baconfat_-_Dreams.mp3") },
    // V4VanessaAfterParty: { url: require("@lss/common/game/assets/sounds/Alex-Productions _ EVIL.mp4") },
    // V8VanessaMCAngelaBeach: { url: require("@lss/common/game/assets/sounds/Hevenize _ Reptile.mp4") },
    // V7ReturningOutfit_McAmber: { url: require("@lss/common/game/assets/sounds/come-get-some.mp3") },
    // V8JennyDate_Bar: { url: require("@lss/common/game/assets/sounds/apple-pie-moonshine.mp3") },
});

